<template>
  <v-dialog v-model="dialog" eager scrollable persistent>
    <template v-slot:activator="{ on, attrs }" pl-3>
      <v-btn
        v-bind="attrs"
        icon
        :title="$t('entitySelect.createNew')"
        v-on="on"
      >
        <v-icon>mdi-plus-circle-outline</v-icon>
      </v-btn>
    </template>

    <PartFormDialog
      @dialogClosed="handleDialogClosed"
      :visible="dialog"
      v-if="dialog"
      @selectedPart="sendSelectedPart"
    />
  </v-dialog>
</template>

<script>
import PartFormDialog from '@/views/parts/PartFormDialog';

export default {
  name: 'PartCreationDialog',

  components: {
    PartFormDialog,
  },

  data() {
    return {
      dialog: false,
    };
  },

  methods: {
    sendSelectedPart(part) {
      this.$emit('selected', part);
    },

    handleDialogClosed() {
      this.dialog = false;
      this.$emit('dialogClosed');
    },
  },
};
</script>
